// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","834":"94726e6d","869":"styles"}[chunkId] + "-" + {"293":"49e6f9c132837332adfc","834":"4468a9f6fcdf6750fea3","869":"216597bcd416e0b8c6dd"}[chunkId] + ".js";
};